import { useLanguage } from "@languages/index"

const TYPE = {
  SEEDING: 1,
  RENTAL: 2,
}

const RENTAL = {
  TYPE,
}

export default RENTAL
